// Definición de defaults

export const defaultTipoAcuerdo: TipoAcuerdoProps = {
    idTipoAcuerdo:        0,
    descripcion:          '',
    listaAcuerdo:         false,
    activo:               false,
}

// Creación de interfaces

export interface TipoAcuerdoProps {
    idTipoAcuerdo:        number;
    descripcion:          string;
    listaAcuerdo:         boolean;
    activo:               boolean;
}